import axios from "axios";

// Both brands are deployed same-origin (frontend + API served from one
// Express process on the site's own domain — see backend-node/src/server.js).
// REACT_APP_BACKEND_URL is a Create React App *build-time* variable; Hostinger's
// Node.js "Environment Variables" screen sets the RUNNING process's env, but
// does not reliably expose that same value to the separate `npm run build`
// step that compiles this file in. When it isn't present at build time this
// used to bake in the literal string "undefined", making every API call
// resolve to "undefined/api" and silently fail — which SiteContext then
// swallowed by falling back to its hardcoded Hindustan Solar Power defaults
// (see SiteContext.jsx), so on a SunExpert deployment every page quietly
// rendered Hindustan's brand/logo instead of erroring loudly.
// Falling back to a same-origin relative "/api" here removes the need for
// this variable in production entirely — only set REACT_APP_BACKEND_URL
// explicitly for local dev, where the frontend dev server and the API run on
// different ports/hosts.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && e.msg) || JSON.stringify(e)).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
